<section class="price-analysis-card" *ngIf="config as chartConfig" [style.height]="chartHeight">
  <header class="price-analysis-header">
    <h3>{{ currentTitle }}</h3>
  </header>

  <div class="price-analysis-state" *ngIf="loading">Loading price analysis...</div>
  <div class="price-analysis-state price-analysis-state--error" *ngIf="!loading && error">{{ error }}</div>
  <div class="price-analysis-state" *ngIf="!loading && !error && !filteredRows.length">
    No data available.
  </div>

  <div
    #chartHost
    class="price-analysis-chart"
    *ngIf="!loading && !error && filteredRows.length">
  </div>

  <div class="price-analysis-bottom-actions" *ngIf="!loading && !error && hasBottomActions">
    <button
      *ngFor="let action of bottomActions; trackBy: trackByBottomAction"
      type="button"
      class="price-analysis-bottom-action"
      [ngClass]="action.className || action.buttonClass || action.variant"
      [ngStyle]="action.style"
      [disabled]="action.disabled === true"
      (click)="onBottomActionClick(action, $event)">
      {{ action.label || action.title || action.key }}
    </button>
  </div>

  <div class="price-analysis-pager" *ngIf="!loading && !error && hasPagedScroller">
    <span>{{ pageStartIndex + 1 }}-{{ pageEndIndex }}</span>
    <input
      class="price-analysis-slider"
      type="range"
      min="0"
      [max]="pagerMax"
      step="1"
      [value]="currentPage"
      (input)="onPagerInput($event)" />
    <span>{{ pageStartIndex + 1 }}-{{ pageEndIndex }} of {{ filteredRows.length }}</span>
  </div>
</section>
